export default __webpack_public_path__ + "/dist/images/membership-icon.72b56454a9f9b88fc9f9fd2e3fef6b48.svg";